import React, { useEffect, useState } from 'react';

/**
 * Brand logo with a monogram fallback.
 *
 * Several vendor logo URLs the portal API returns are dead (the Cloudinary
 * D2C Merchants folder 404s), which used to leave broken-image icons all over
 * the marketplace. Mirrors BrandLogo in the fleek-web-app marketplace: on
 * error we render the brand's initial in the same box, sized by whatever
 * class the caller passed.
 */
const BrandLogo = ({ src, name, className = '', alt, fallback, loading = 'lazy' }) => {
  const [failed, setFailed] = useState(!src);

  // A new src deserves a fresh attempt — otherwise a card recycled by React
  // keeps the previous brand's failed state.
  useEffect(() => {
    setFailed(!src);
  }, [src]);

  if (failed) {
    // Callers showing a brand as the headline (the partner in the navbar) pass
    // their own fallback — an initial is too thin to lead a page with.
    if (fallback) return fallback;

    const initial = (name || '?').trim().charAt(0).toUpperCase();
    return (
      <span className={`${className} logoFallback`} aria-hidden="true">
        {initial}
      </span>
    );
  }

  return (
    <img
      className={className}
      src={src}
      alt={alt ?? name ?? ''}
      loading={loading}
      onError={() => setFailed(true)}
    />
  );
};

export default BrandLogo;
